import React from 'react'

import { Button } from '@/components/ui/button'
import { Alert } from '@/components/ui/alert'
import { Spinner } from '@/components/ui/spinner'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog'

export default function LinkToDeliverable({
  requestClose,
  sourceLink,
  show,
  hasError,
  error,
  loading
}) {
  return (
    <Dialog open={show} onOpenChange={o => { if (!o) requestClose() }}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Download Deliverable</DialogTitle>
        </DialogHeader>

        <div className="space-y-3 text-sm">
          {hasError && <Alert variant="error">{error}</Alert>}

          {loading && (
            <div className="flex items-center gap-2 text-muted-foreground">
              <Spinner size={18} /> Preparing your link…
            </div>
          )}

          <p className="text-muted-foreground">
            Note: Deliverables should be received through your preferred AberFast Delivery method. If you are not
            receiving files through the preferred method, contact{' '}
            <a className="text-primary hover:underline" href="mailto:aberfast@abercap.com">aberfast@abercap.com</a>.
          </p>
          <p className="text-muted-foreground">
            Downloading the deliverable from this link is your backup option for when you are unable to receive
            files through your preferred method. The link expires in 7 days.
          </p>

          {sourceLink && (
            <a
              href={sourceLink}
              target="_blank"
              rel="noreferrer"
              className="block break-all font-medium text-primary hover:underline"
            >
              {sourceLink}
            </a>
          )}
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={requestClose}>Close</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
